<template>
    <div>
        <div id="lineChart">

        </div>
    </div>
</template>

<script>
    import {EleResize} from "@/utils/esresize.js";
    import store from '@/store/index.js';
    import {lang} from "@/utils/language.js";
    import echarts from 'echarts';

    export default {
        name: "LineChart",
        store,
        props: {
            line_chart_data: {
                type: Object
            },
            changeCount: {
                type: Number,
                default: 0
            },
            minInterval:{
                type:Number,
                default: 1
            }
        },
        data() {
            return {
                lang: lang,
                stateLang: '',
            }
        },
        mounted() {
            this.setChart();
        },
        methods: {
            drawLinChart(dom, option) {
                let myChart = echarts.init(document.getElementById(dom));
                let resizeDiv = document.getElementById(dom)
                //绘制图表
                myChart.setOption(option);
                let listener = function () {
                    myChart.resize()
                }
                EleResize.on(resizeDiv, listener)
            },
            setChart() {
                let dom = 'lineChart';
                let series = null;
                let value =  this.line_chart_data.seriesData;
                if(Object.prototype.toString.call(value) == "[object Array]"){
                    series = [{
                        name: "seriesName" in this.line_chart_data?this.line_chart_data.seriesName:"",
                        type: 'line',
                        data: value
                    }]
                }else if(Object.prototype.toString.call(value) == "[object Object]"){
                    series = value.data;
                }
                let option = {
                    color: ['#3398DB'],
                    title: {
                        text: this.line_chart_data.title,
                        x: 'center'
                    },
                    tooltip: {
                        trigger: 'axis',
                        formatter: this.line_chart_data.tooltipFormatter
                    },
                    grid: {
                        left: '5%',
                        right: '10%',
                        bottom: '3%',
                        containLabel: true
                    },
                    dataZoom: {
                        show: true,
                        realtime: true,
                        y: 36,
                        height: 20,
                        start: 0,
                        end: 80
                    },
                    xAxis: {
                        type: 'category',
                        data: this.line_chart_data.xAxisArr,
                        axisLabel: {
                            interval: 0,//横轴信息全部显示
                            rotate: -20,// -20度角倾斜显示
                        }
                    },
                    yAxis: {
                        minInterval: this.minInterval,
                        type: 'value',
                        axisLabel: {
                            formatter: '{value}' + this.line_chart_data.yUnitText
                        }
                    },
                    legend: {
                        orient: 'horizontal',
                        top: 'top',
                        data: 'legendData' in this.line_chart_data?this.line_chart_data.legendData:[],
                    },
                    series: series,
                }
                this.drawLinChart(dom, option)
            },
        },
        computed: {
            language: function () {
                this.stateLang = store.state.lang;
                return store.state.lang;
            },

        },

        watch: {
            stateLang: function () {
                this.setChart();
            },
            changeCount: function () {
                this.setChart();
            }
        },

    }
</script>

<style scoped>
    #lineChart {
        width: 100%;
        height: 500px;
    }
</style>
